import { useMapElement } from '../../contextProviders/MapElementProvider';
import OutcomeDetails from '../OutcomeDetails';
import screens from '../screens';
import WaitConfiguration from './WaitConfiguration';

const WaitRouter = () => {
    const {
        currentScreen,
        mapElement,
        selectedOutcomeIndex,
        onSwitchScreen,
        setSelectedOutcomeIndex,
    } = useMapElement();

    switch (currentScreen) {
        case screens.wait:
            return <WaitConfiguration />;

        case screens.outcome: {
            const selectedOutcome = mapElement.outcomes?.[selectedOutcomeIndex ?? 0] ?? null;

            return (
                <OutcomeDetails
                    outcome={selectedOutcome}
                    onSave={() => {
                        onSwitchScreen(screens.wait);
                    }}
                    onCancel={() => {
                        onSwitchScreen(screens.wait);
                        setSelectedOutcomeIndex(null);
                    }}
                />
            );
        }
        default:
            return null;
    }
};

export default WaitRouter;
